module.exports = __webpack_public_path__ + "img/warning_icon.9a0e0142.svg";